import { notification } from 'antd';

/**
 * SbNotification - Standardized notification wrapper for SkillsBridge
 * 
 * Wraps Ant Design's notification API with consistent styling and behavior.
 * 
 * Usage:
 *   import { SbNotification } from 'uiCore';
 *   
 *   SbNotification.success('Operation completed', 'Your changes have been saved');
 *   SbNotification.error('Operation failed', 'Please try again');
 *   SbNotification.warning('Warning', 'This action cannot be undone');
 *   SbNotification.info('Info', 'New features available');
 */

const defaultConfig = {
  placement: 'top',
};

const SbNotification = {
  success: (message, description = '', config = {}) => {
    notification.success({
      message,
      description,
      ...defaultConfig,
      duration: 4,
      ...config,
    });
  },

  error: (message, description = '', config = {}) => {
    notification.error({
      message,
      description,
      ...defaultConfig,
      duration: 5,
      ...config,
    });
  },

  warning: (message, description = '', config = {}) => {
    notification.warning({
      message,
      description,
      ...defaultConfig,
      duration: 8,
      ...config,
    });
  },

  info: (message, description = '', config = {}) => {
    notification.info({
      message,
      description,
      ...defaultConfig,
      duration: 5,
      ...config,
    });
  },

  // Direct access to underlying notification API for advanced use cases
  open: (config) => {
    notification.open({
      ...defaultConfig,
      ...config,
    });
  },

  // Utility methods
  destroy: (key) => {
    notification.destroy(key);
  },

  config: (options) => {
    notification.config(options);
  },
};

export default SbNotification;
